import React from 'react';
import {Col} from 'antd';
import commonExtendsHOC from '../commonExtendsHOC';

export default commonExtendsHOC(Col);